<script setup lang="ts">
import axios from 'axios';
import { computed, onMounted, ref } from 'vue';
import Notification from '../dto/response/Notification';
import OtEquipmentPreview from './EquipmentPreview.vue';
import { OtSelect, OtSelectContent, OtSelectGroup, OtSelectItem, OtSelectTrigger, OtSelectValue } from './select';

interface Props {
    competition: string;
    type: string;
}
const props = defineProps<Props>();

const modelValue = ref(null);
const list = ref([]);
const selected = computed(() => list.value.find(equipment => equipment.item.id.toString() === modelValue.value));
onMounted(load);
async function load() {
    const { data } = await axios.get(`/api/players/me/equipment/${props.type}`);
    list.value = data.data;
    modelValue.value = list.value.find(equipment => equipment.isSetFor[props.competition])?.item.id.toString();
}

async function update() {
    await axios.put(`/api/players/me/equipment/${props.type}`, {
        competition: props.competition,
        id: Number.parseInt(modelValue.value),
    });
    window.emitter.emit('notification', Notification.success(`${props.type}_set`));
}
</script>

<template>
    <ot-select
        v-model="modelValue"
        @update:model-value="update"
    >
        <ot-select-trigger>
            <ot-select-value>
                <ot-equipment-preview v-if="selected" :equipment="selected" :type="type" />
            </ot-select-value>
        </ot-select-trigger>
        <ot-select-content>
            <ot-select-group>
                <ot-select-item
                    v-for="equipment in list"
                    :key="equipment.item.id"
                    :value="equipment.item.id.toString()"
                >
                    <ot-equipment-preview :equipment="equipment" :type="type" />
                </ot-select-item>
            </ot-select-group>
        </ot-select-content>
    </ot-select>
</template>
